module.exports = __webpack_public_path__ + "img/search.8d261361.svg";